import { render, staticRenderFns } from "./Template5.vue?vue&type=template&id=fe2a9f0c&"
import script from "./Template5.vue?vue&type=script&lang=js&"
export * from "./Template5.vue?vue&type=script&lang=js&"
import style0 from "./Template5.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe2a9f0c')) {
      api.createRecord('fe2a9f0c', component.options)
    } else {
      api.reload('fe2a9f0c', component.options)
    }
    module.hot.accept("./Template5.vue?vue&type=template&id=fe2a9f0c&", function () {
      api.rerender('fe2a9f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/Template5.vue"
export default component.exports